import { createBrowserHistory } from "history";
import { makeRootReducer } from "./rootReducers";
import { routerMiddleware } from "connected-react-router";
import { compose, createStore, applyMiddleware } from "redux";

// Create a history of your choosing (we're using a browser history in this case)
const history = createBrowserHistory();

// Build the middleware for intercepting and dispatching navigation actions
const routeMiddleware = routerMiddleware(history);

// Combine middleware
const middlewares = [routeMiddleware];

const store = createStore(
  makeRootReducer(history),
  compose(applyMiddleware(...middlewares))
);

export { history, store };
